module.exports = "<div class=\"sk-spinner sk-spinner-cube-grid\" style=\"{{inline?'display: inline-block; transform: scale(0.5);':'margin-top: 90px; margin-bottom: 90px;'}}\">\n  <div class=\"sk-cube\"></div>\n  <div class=\"sk-cube\"></div>\n  <div class=\"sk-cube\"></div>\n  <div class=\"sk-cube\"></div>\n  <div class=\"sk-cube\"></div>\n  <div class=\"sk-cube\"></div>\n  <div class=\"sk-cube\"></div>\n  <div class=\"sk-cube\"></div>\n  <div class=\"sk-cube\"></div>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/util/Spinner.html
// module id = 306
// module chunks = 0